import { captureMessage } from '@sentry/react';
import type { Data, WebSocketError } from '@/context/channels/types';

export const logWebSocketError = (
  subscriptionData: Data,
  error: WebSocketError
) => {
  captureMessage(
    `WebSocket Error: [${subscriptionData.resource_type} | ${subscriptionData.resource_id}] ${error.message}`,
    {
      level: 'error',
      tags: {
        component: 'websocket',
        resource_type: subscriptionData.resource_type,
        error_type: error.error,
        status_code: error.status,
      },
      contexts: {
        websocket: {
          channel: subscriptionData.channel,
          resource_type: subscriptionData.resource_type,
          resource_id: subscriptionData.resource_id,
          error: error.error,
          status: error.status,
          message: error.message,
        },
      },
    }
  );
};
